// extracted by mini-css-extract-plugin
export default {"l_Overlay_main":"Overlay_l_Overlay_main__mx9ea","open":"Overlay_open__VUWFC"};